import React from "react";

export default function AboutPage() {
  const features = [
    {
      icon: "🏠",
      title: "Mang cơm từ nhà",
      description: "Đăng ký trạng thái mang cơm từ nhà"
    },
    {
      icon: "🛒",
      title: "Đặt đồ ăn",
      description: "Tham gia đặt đồ ăn cùng team"
    },
    {
      icon: "🚫",
      title: "Không ăn",
      description: "Đánh dấu không ăn trưa hôm nay"
    },
    {
      icon: "👥",
      title: "Quản lý nhóm",
      description: "Theo dõi trạng thái ăn trưa của cả team"
    },
    {
      icon: "📊",
      title: "Thống kê",
      description: "Xem tổng quan và thống kê theo thời gian thực"
    },
    {
      icon: "🔔",
      title: "Thông báo",
      description: "Nhận thông báo về orders mới và deadline"
    }
  ];

  const techStack = [
    { name: "React", version: "18.2.0", icon: "⚛️" },
    { name: "TypeScript", version: "5.0.0", icon: "📘" },
    { name: "Tailwind CSS", version: "4.1.12", icon: "🎨" },
    { name: "Supabase", version: "2.56.0", icon: "🗄️" },
    { name: "Microsoft Teams", version: "2.43.0", icon: "👥" },
    { name: "Azure MSAL", version: "3.14.0", icon: "🔐" }
  ];

  return (
    <div className="container mx-auto px-4 py-8">
        <header className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-blue-500/20 to-purple-500/20 border border-blue-500/30 mb-4">
            <span className="text-3xl">ℹ️</span>
          </div>
          <h1 className="text-4xl font-bold text-white mb-4">
            Về Lunch Buddy
          </h1>
          <p className="text-slate-300 text-xl max-w-2xl mx-auto leading-relaxed">
            Ứng dụng quản lý ăn trưa thông minh, giúp team dễ dàng phối hợp và tổ chức việc ăn trưa hàng ngày.
          </p>
        </header>

        <div className="max-w-6xl mx-auto space-y-12">
          {/* Features */}
          <section>
            <h2 className="text-3xl font-bold text-white text-center mb-8">
              ✨ Tính năng chính
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-slate-800/50 backdrop-blur-sm border border-slate-600/50 rounded-2xl p-6 hover:border-slate-500/50 transition-all"
                >
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-emerald-500/20 to-blue-500/20 border border-emerald-500/30 flex items-center justify-center mb-4">
                    <span className="text-2xl">{feature.icon}</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                  <p className="text-slate-400">{feature.description}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Tech Stack */}
          <section>
            <h2 className="text-3xl font-bold text-white text-center mb-8">
              🛠️ Công nghệ sử dụng
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {techStack.map((tech, index) => (
                <div
                  key={index}
                  className="bg-slate-800/30 backdrop-blur-sm border border-slate-600/30 rounded-xl p-4 flex items-center gap-3"
                >
                  <span className="text-2xl">{tech.icon}</span>
                  <div>
                    <h4 className="text-white font-medium">{tech.name}</h4>
                    <p className="text-slate-400 text-sm">v{tech.version}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* How it works */}
          <section>
            <h2 className="text-3xl font-bold text-white text-center mb-8">
              🔄 Cách hoạt động
            </h2>
            <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-600/50 rounded-2xl p-8">
              <div className="grid md:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-500/20 to-blue-500/20 border border-emerald-500/30 flex items-center justify-center mx-auto mb-4">
                    <span className="text-3xl">1️⃣</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">Đăng nhập</h3>
                  <p className="text-slate-400">
                    Sử dụng tài khoản Microsoft để đăng nhập an toàn
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-orange-500/20 to-red-500/20 border border-orange-500/30 flex items-center justify-center mx-auto mb-4">
                    <span className="text-3xl">2️⃣</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">Chọn trạng thái</h3>
                  <p className="text-slate-400">
                    Chọn mang cơm, đặt đồ ăn hoặc không ăn trưa
                  </p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 rounded-full bg-gradient-to-br from-purple-500/20 to-pink-500/20 border border-purple-500/30 flex items-center justify-center mx-auto mb-4">
                    <span className="text-3xl">3️⃣</span>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-2">Theo dõi</h3>
                  <p className="text-slate-400">
                    Xem trạng thái của team và tham gia orders
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="text-center">
            <div className="bg-slate-800/30 backdrop-blur-sm border border-slate-600/30 rounded-2xl p-8">
              <h2 className="text-2xl font-bold text-white mb-4">
                📞 Hỗ trợ & Liên hệ
              </h2>
              <p className="text-slate-400 mb-6">
                Cần hỗ trợ hoặc có góp ý về ứng dụng? Liên hệ với chúng tôi!
              </p>
              <div className="flex justify-center gap-4">
                <a
                  href="mailto:support@lunchbuddy.com"
                  className="px-6 py-3 rounded-xl bg-gradient-to-r from-emerald-500 to-blue-500 hover:from-emerald-600 hover:to-blue-600 text-white font-medium transition-all"
                >
                  📧 Email hỗ trợ
                </a>
                <a
                  href="#"
                  className="px-6 py-3 rounded-xl border border-slate-600/50 bg-slate-700/50 hover:bg-slate-700 text-white font-medium transition-all"
                >
                  📚 Tài liệu
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
  );
}
